var map = {
	"./b_bronze_large.svg": 979,
	"./b_gold_large.svg": 980,
	"./b_negative.svg": 981,
	"./b_neutral.svg": 982,
	"./b_notratable.svg": 983,
	"./b_silver_large.svg": 984,
	"./b_underreview.svg": 985
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1602;



//////////////////
// WEBPACK FOOTER
// ./src/client/images ^\.\/b_.*\.svg$
// module id = 1602
// module chunks = 0